<script setup lang="ts">
defineProps({ blok: Object })

const { state } = useAppStore()
</script>

<template>
    <section>
        <header class="bg-chsc-yellow py-20">
            <UiContainer>
                <h2 class="font-eb-garamond text-center fs-6xl text-chsc-indigo-500">
                    · {{ blok?.title }} ·
                </h2>
            </UiContainer>
        </header>
        <UiContainer>
            <div class="mt-32">
                <div
                    v-for="category in state.categories"
                    :key="category.id"
                    class="border border-gray-200 rounded-t-3xl mb-12"
                >
                    <header class="flex items-center gap-x-12 px-12 py-12 border-b border-gray-200 max-[641px]:gap-x-6 max-[641px]:px-6 max-[641px]:py-6">
                        <span
                            class="[&>svg]:h-[55px] max-[641px]:[&>svg]:h-[35px]"
                            v-html="category.icon"
                        />
                        <h2 class="fs-3xl text-chsc-indigo-500 font-eb-garamond font-medium">
                            {{ category.name }}
                        </h2>
                    </header>
                    <div>
                        <div
                            v-for="question in category.questions"
                            :key="question.id"
                            class="flex border-b border-gray-200 max-[641px]:flex-col"
                        >
                            <div class="flex-1 p-12 border-r border-gray-200 max-[641px]:border-b max-[641px]:border-gray-200 max-[641px]:p-6">
                                <p class="font-semibold whitespace-pre-wrap fs-xl">
                                    {{ question.text }}
                                </p>
                            </div>
                            <div class="flex-1 p-12 fs-lg">
                                <p class="whitespace-pre-wrap">
                                    {{ question.criteria }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- <pre>{{ category }}</pre> -->
                </div>
            </div>
        </UiContainer>
    </section>
</template>
